// import { wxHost } from '@/utils/http/baseUrl'
import jsCookie from 'js-cookie'
import StoreController from '@/controllers/storeController/view/store/store.controller.js'
import ConfigModel from '@store/models/config/config.model'
import { getParams, getLocal } from '@/utils/utils.js'
import {
  setCacheInfo,
  getCacheInfo,
} from '@/utils/http/modules/agent/agent.request'
export const checkIsVzanHost = () => {
  return location.host.includes('.vzan.com')
}

export const toVzanHostPath = async (search = {}, path = '') => {
  const urlParams = new URLSearchParams(location.search)
  const zbid = urlParams.get('zbid')
  const _id = jsCookie.get('supplier_relation_id_' + zbid) || ''
  const token = jsCookie.get('supplier_relation_token_' + zbid) || ''
  const vz_uid = jsCookie.get('zbvz_userid') || ''
  const wxHost = window.zbvd.wapDomainUrl || 'https://h5.vzan.com'
  let _search = {
    ...search,
    srId: _id,
    srTk: token,
    vz_uid,
  }

  const isStore = StoreController.isStore()
  if (isStore) {
    const localStorageData = {}
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      localStorageData[key] = localStorage.getItem(key)
    }
    const cookie = jsCookie.get('zbvz_userid')
    const data = JSON.stringify({
      localStorageData,
      cookie,
    })
    try {
      let res = await setCacheInfo({
        data,
      })
      _search = {
        ...search,
        storeSign: res.dataObj,
      }
    } catch (err) {
      console.log(err)
    }
  }
  const originSearch = location.search
  const customSearch = Object.keys(_search)
    .reduce((res, key) => {
      res.push(`${key}=${_search[key]}`)
      return res
    }, [])
    .join('&')
  const signal = originSearch.includes('?') ? '&' : '?'

  if (!path) {
    location.replace(
      wxHost + location.pathname + originSearch + signal + customSearch
    )
  } else {
    location.replace(wxHost + path + '?' + customSearch)
  }
}

export const fromVzanHostPath = async (search = {}, path = '') => {
  const { storeSign } = getParams()
  if (storeSign) {
    try {
      let res = await getCacheInfo({
        key: storeSign,
      })
      let data = JSON.parse(res.dataObj)
      const localStorageData = data.localStorageData
      const cookie = data.cookie
      for (let key in localStorageData) {
        localStorage.setItem(key, localStorageData[key])
      }
      jsCookie.set('zbvz_userid', cookie)
    } catch (err) {
      console.log(err)
    }
  }
}
